import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" style={{ height: '100px' }}>
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/bf28291cc5d7f0a9c8281f40e0310854/bac760dd5111dec7a1acf46dcaf57f3b.jpeg"
              alt="縦長ジョブ"
              className="h-16 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="text-sm text-gray-600 hover:text-black cursor-pointer flex items-center gap-1"
          >
            <i className="ri-arrow-left-line"></i>
            戻る
          </Link>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-gray-900">利用規約</h1>
        
        <div className="prose prose-gray max-w-none">
          <p className="text-gray-700 leading-relaxed mb-8">
            この利用規約（以下「本規約」といいます。）は、縦長ジョブ（以下「当方」といいます。）が運営する縦長ジョブ（以下「当サイト」といいます。）の利用条件を定めるものです。ユーザーは、当サイトを利用することにより、本規約に同意したものとみなされます。
          </p>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第1条（適用）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              本規約は、当サイトの利用に関する当方とユーザーとの間の一切の関係に適用されます。
            </p>
            <p className="text-gray-700 leading-relaxed">
              当方は、当サイト上で、本規約のほか、個別ルール、ガイドライン、注意事項等を定めることがあります。これらは本規約の一部を構成するものとします。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第2条（当サイトの内容）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              当サイトは、TikTokその他第三者が提供する動画、プロフィール、リンク、関連情報等を紹介、分類、表示または案内するキュレーションサービスです。当サイトは、紹介対象となる動画またはアカウントの権利者、運営者または所属先を代表するものではありません。
            </p>
            <p className="text-gray-700 leading-relaxed">
              当サイト上で表示される動画その他の外部コンテンツは、第三者の提供するサービスまたは情報に基づくものであり、その内容、正確性、完全性、最新性または適法性について当方が保証するものではありません。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第3条（知的財産権）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              当サイトに掲載される文章、画像、デザイン、ロゴ、構成その他当方が作成したコンテンツに関する著作権その他の知的財産権は、当方または正当な権利者に帰属します。
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              当サイト上で紹介または埋め込み表示されるTikTok動画、アカウント情報その他第三者コンテンツに関する権利は、当該権利者に帰属します。
            </p>
            <p className="text-gray-700 leading-relaxed">
              ユーザーは、法令で認められる範囲を超えて、当サイト上のコンテンツを無断で複製、転載、公衆送信、改変、再配布その他利用してはなりません。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第4条（禁止事項）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              ユーザーは、当サイトの利用にあたり、以下の行為をしてはなりません。
            </p>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>当サイト、TikTokその他第三者の権利または利益を侵害する行為</li>
              <li>当サイトの運営を妨害し、または妨害するおそれのある行為</li>
              <li>当サイトに対する不正アクセス、スクレイピング、過度な自動取得その他サーバーに過度な負荷を与える行為</li>
              <li>虚偽の情報を送信する行為</li>
              <li>当サイトを通じて取得した情報を、当方または権利者の承諾なく営業目的その他不適切な目的で利用する行為</li>
              <li>反社会的勢力に利益を供与する行為</li>
              <li>その他、当方が不適切と判断する行為</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第5条（外部サービス）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              当サイトには、TikTokその他第三者のウェブサイト、サービス、広告または埋め込みコンテンツが含まれる場合があります。
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              ユーザーが外部サービスを利用する場合、当該外部サービスの利用規約、プライバシーポリシーその他の条件に従うものとします。
            </p>
            <p className="text-gray-700 leading-relaxed">
              当方は、外部サービスの内容、継続性、正確性、安全性等について責任を負いません。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第6条（リンク）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              当サイトへのリンクは、公序良俗に反しない限り、原則として自由とします。
            </p>
            <p className="text-gray-700 leading-relaxed">
              ただし、当方は、リンク元の内容や態様が不適切であると判断した場合、リンクの削除を求めることができます。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第7条（掲載停止・削除等）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              当方は、当サイト上で紹介または表示しているコンテンツについて、権利侵害その他の問題があると判断した場合、事前通知なく、掲載停止、削除、表示制限その他必要な措置を講じることができます。
            </p>
            <p className="text-gray-700 leading-relaxed">
              権利者その他利害関係人から申立てがあった場合、当方は、必要な確認を行ったうえで、適切に対応します。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第8条（免責）</h2>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-3">
              <li>当方は、当サイトに事実上または法律上の瑕疵がないことを保証しません。</li>
              <li>当方は、当サイトの利用または利用不能によりユーザーに生じた損害について、当方に故意または重過失がある場合を除き、責任を負いません。</li>
              <li>当方は、当サイトに掲載された外部コンテンツ、リンク先情報、第三者広告その他第三者提供情報に起因して生じた損害について責任を負いません。</li>
              <li>当方は、通信回線、システム障害、外部サービスの停止、仕様変更等により当サイトの全部または一部が利用できない場合であっても、責任を負いません。</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第9条（サービス内容の変更・停止）</h2>
            <p className="text-gray-700 leading-relaxed">
              当方は、保守、障害対応、外部サービスの変更、運営上または技術上の理由その他必要がある場合、ユーザーに事前に通知することなく、当サイトの全部または一部の内容を変更し、または提供を停止・終了することができます。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第10条（規約の変更）</h2>
            <p className="text-gray-700 leading-relaxed">
              当方は、必要と判断した場合、民法その他法令に従い、本規約を変更することができます。変更後の本規約は、当サイト上に掲載した時点または当方が別途定める効力発生日から効力を生じるものとします。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第11条（分離可能性）</h2>
            <p className="text-gray-700 leading-relaxed">
              本規約の一部が法令等により無効または執行不能と判断された場合であっても、その余の規定は引き続き有効に存続するものとします。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">第12条（準拠法・裁判管轄）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              本規約の準拠法は日本法とします。
            </p>
            <p className="text-gray-700 leading-relaxed">
              当サイトに関して紛争が生じた場合、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">制定日：2025年1月1日</p>
            <p className="text-sm text-gray-500">最終改定日：2025年1月1日</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-12 px-4 bg-gray-900 text-white mt-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <img
                src="https://static.readdy.ai/image/bf28291cc5d7f0a9c8281f40e0310854/bac760dd5111dec7a1acf46dcaf57f3b.jpeg"
                alt="縦長ジョブ"
                className="h-48 w-auto mb-4"
              />
              <p className="text-sm text-gray-400">
                縦動画で見つける、新しい仕事との出会い
              </p>
            </div>
            <div>
              <h4 className="font-bold mb-4">サイトマップ</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>
                  <Link to="/" className="hover:text-white cursor-pointer">
                    ホーム
                  </Link>
                </li>
                <li>
                  <Link to="/sessions" className="hover:text-white cursor-pointer">
                    説明会一覧
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="hover:text-white cursor-pointer">
                    利用規約
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="hover:text-white cursor-pointer">
                    プライバシーポリシー
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4">対象業界</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>飲食</li>
                <li>小売</li>
                <li>物流</li>
                <li>製造</li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
            <p>
              © 2025 縦長ジョブ. All rights reserved. |{' '}
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white cursor-pointer"
              >
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}